import React from 'react';
import { BillingConfig } from '../../../types/billing';
import { formatDateTime, formatMoney } from '../../../utils/billingMoney';
import { BillingSheet } from '../BillingSheet';
import { ReportSection, ReportTable } from './ReportTable';
type Props = {
  config: BillingConfig;
  title: string;
  period: string;
  basis: string;
  filters: string;
  sections: ReportSection[];
  generatedBy: string;
  internal?: boolean;
};

/** Printable / PDF version of a billing report on the configured report paper. */
export function ReportPaper({
  config,
  title,
  period,
  basis,
  filters,
  sections,
  generatedBy,
  internal
}: Props) {
  const issuer = {
    business: config.business,
    appearance: config.appearance,
    regional: config.regional
  };
  const fmt = (v: number) => formatMoney(v, config.regional.currencySymbol);
  return <BillingSheet issuer={issuer} data-id="element-4628" data-mp="2yz5p9xr76yeu">
      <header className="border-b-2 pb-3" style={{
      borderColor: config.appearance.accentColor
    }} data-id="element-4629" data-mp="2yy30pwhcl823">
        <div className="flex items-start justify-between gap-4" data-id="element-4630" data-mp="2u01ifdrqxcro">
          <div data-id="element-4631" data-mp="2zt92a7b4gi8p">
            <p className="text-[13px] font-extrabold" style={{
            color: config.appearance.accentColor
          }} data-id="element-4632" data-mp="2zrpqou0euvd9">{config.business.name}</p>
            <p className="text-[9.5px] text-slate-600" data-id="element-4633" data-mp="34pzmn6tylzzx">{config.business.addressLine1}{config.business.addressLine2 ? `, ${config.business.addressLine2}` : ''}{config.business.tpin ? ` · TPIN ${config.business.tpin}` : ''}</p>
          </div>
          {config.business.logoUrl && <img src={config.business.logoUrl} alt="" crossOrigin="anonymous" className="h-12 w-12 object-contain" data-id="element-4634" data-mp="2guwtwns1bce6" />}
        </div>
        <h1 className="mt-3 text-[17px] font-bold uppercase tracking-wide" data-id="element-4635" data-mp="2lt83qyibxmwe">{title}</h1>
        {internal && <p className="mt-0.5 inline-block rounded border border-amber-600 px-1.5 text-[9px] font-bold uppercase tracking-wider text-amber-700" data-id="element-4636" data-mp="2qqrhzyf11zoc">Internal report — not a statutory return</p>}
        <p className="mt-1 text-[10.5px] font-semibold" data-id="element-4637" data-mp="61af9b2mhf5s">{period}</p>
        <p className="text-[9px] text-slate-600" data-id="element-4638" data-mp="a2nnfrt6tufv">{basis}</p>
        {filters && <p className="text-[9px] text-slate-600" data-id="element-4639" data-mp="2741o7cclfxuf">Filters: {filters}</p>}
      </header>
      {sections.map(s => <ReportTable key={s.title} section={s} fmt={fmt} variant="paper" data-id="element-4640" data-mp="2258g5zg2sz1n" />)}
      <footer className="mt-auto border-t border-slate-300 pt-2 text-[8.5px] text-slate-500" data-id="element-4641" data-mp="227b5eh9emo5b">Generated {formatDateTime(new Date().toISOString())} (Africa/Lusaka) by {generatedBy} · Amounts in {config.regional.currency}</footer>
    </BillingSheet>;
}